/**
 * DM-7976: the live-versus-draft view of a charity profile, shared by the
 * Charity Verification drawer and the Moderation drawer (a report whose
 * target is an ORGANIZATION carries the same two blocks).
 */

import type { ProfileFieldsWire } from '../api/adminOps';

export type ProfileFieldKey = keyof ProfileFieldsWire;

/** In display order; the keys are the wire keys of ProfileFieldsWire. */
export const PROFILE_FIELDS: readonly { readonly key: ProfileFieldKey; readonly label: string }[] =
  [
    { key: 'display_name_choice', label: 'Display name choice' },
    { key: 'display_name', label: 'Display name' },
    { key: 'category', label: 'Category' },
    { key: 'mission', label: 'Mission' },
    { key: 'short_description', label: 'Short description' },
    { key: 'website_url', label: 'Website URL' },
    { key: 'logo_url', label: 'Logo' },
    { key: 'cover_url', label: 'Cover' },
  ];

export interface ProfileFieldDiff {
  readonly key: ProfileFieldKey;
  readonly label: string;
  readonly live: string | null;
  readonly draft: string | null;
  /** False when there is no draft at all, or the draft repeats the live value. */
  readonly changed: boolean;
}

/** One row per profile field. Without a draft every row is unchanged. */
export function profileDiff(
  live: ProfileFieldsWire,
  draft: ProfileFieldsWire | null
): ProfileFieldDiff[] {
  return PROFILE_FIELDS.map(({ key, label }) => {
    const liveValue = live[key];
    const draftValue = draft === null ? null : draft[key];
    return {
      key,
      label,
      live: liveValue,
      draft: draftValue,
      changed: draft !== null && draftValue !== liveValue,
    };
  });
}

export function changedFieldCount(diff: readonly ProfileFieldDiff[]): number {
  return diff.filter(field => field.changed).length;
}
